import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  tooltip: {
    ...theme.tooltip?.box,
    boxShadow: "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 2px rgb(0 0 0 / 12%)",
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: "pre-line"
  },
  trigger: {
    display: "inline-flex",
    alignItems: "center"
  },
  icon: {
    width: 14,
    height: 14,
    color: "#aaa2aa"
  }
}));

export default useStyles;
